import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jt-alert',
  templateUrl: './jt-alert.component.html',
  styleUrls: ['./jt-alert.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JtAlertComponent {


  @Input() type: 'primary' | 'secondary' | 'success' | 'danger'
    | 'warning' | 'info' | 'light' | 'dark' = 'info';

  @Input() dismissible: boolean = false;
  @Input() icon: string = '';
  @Input() extraClass: string = '';
  visible: boolean = true;
  @Output() byDismiss = new EventEmitter<void>();

  dismiss(): void {
    this.visible = false;
    this.byDismiss.emit();
  }
}
